// extracted by mini-css-extract-plugin
export default {"inputWrapper":"PhoneInput_inputWrapper__8bNZP","label":"PhoneInput_label__9MbKY","error":"PhoneInput_error__IoNhR","input":"PhoneInput_input__xh1nP"};